if(!customElements.get('accordions-component')) {
  customElements.define(
    'accordions-component',
    class AccordionsComponent extends HTMLElement {
      #accordions;
      
      constructor() {
        super();
      }

      connectedCallback() {
        this.#accordions = this.querySelectorAll('.accordion') ?? [];
        this.init();
      }

      init() {
        this.#accordions.forEach((accordion) => {
          const summary = accordion.querySelector('.summary');
          if (!summary) return;

          summary.addEventListener('click', () => {
            this.toggleAccordion(accordion);
          });
        });
      }

      toggleAccordion(activeAccordion) {
        this.#accordions.forEach((accordion) => {
          const content = accordion.querySelector('.accordion-content');
          const inner = content.querySelector('.content-layout') || content.querySelector('.content-inner');

          if (!content || !inner) return;

          const isActive = accordion === activeAccordion;
          const isOpen = accordion.dataset.state === 'open';

          const innerStyles = window.getComputedStyle(inner);
          const innerMarginTop = parseFloat(innerStyles.marginTop) || 0;
          const innerMarginBottom = parseFloat(innerStyles.marginBottom) || 0;

          const innerTotalMargin = inner.scrollHeight + innerMarginTop + innerMarginBottom;

          if (isActive && !isOpen) {
            accordion.dataset.state = 'open';
            content.style.height = `${innerTotalMargin}px`;
          } else {
            accordion.dataset.state = 'closed';
            content.style.height = `${innerTotalMargin}px`;
            requestAnimationFrame(() => {
              content.style.height = '0px';
            });
          }
        });
      }
    }
  );
}